import SanitySplitBlock from '../SanitySplitBlock';

export default function SplitBlockSerializer({ node }) {
  return <SanitySplitBlock {...node} />;
}
